<template>
  <v-expansion-panel
    class="patient-section"
    v-bind:disabled="disabled"
    v-bind:focusable="false"
  >
    <v-expansion-panel-header class="patient-section__header">
      <template v-slot:actions>
        <v-icon class="patient-section__arrow" />
      </template>
      <slot name="header">
        <div class="patient-section__column">
          <slot name="label">
            {{ label }}
          </slot>
          <slot name="after-label" />
          <em
            v-if="description"
            class="patient-section__description"
          >{{ description }}</em>
        </div>
        <slot name="after-header" />
      </slot>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="patient-section__body" eager>
      <slot />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
/**
 * @description Компонент управления (шина) группы секций.
 * @type {Vue}
 */
export const PatientSectionControl = {
  props: {
    value: {
      default: () => [],
      required: false,
      type: Array, // @link https://v2.vuetifyjs.com/en/api/v-expansion-panels/#props
    },
  },
  render(createElement) {
    const emitInputEvent = (value) => this.$emit('input', value);
    return createElement(
      'v-expansion-panels',
      {
        on: {
          change(updatedValue) {
            emitInputEvent(updatedValue);
          },
        },
        props: {
          multiple: true,
          value: this.value,
        },
      },
      this.$slots.default,
    );
  },
};

export default {
  props: {
    /**
     * @description Описание.
     * @type {string}
     */
    description: {
      default: () => '',
      type: String,
    },
    /**
     * @description Отключен.
     * @type {boolean}
     */
    disabled: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Заголовок.
     * @type {string}
     */
    label: { required: true, type: String },
  },
};
</script>
<style scoped lang="scss">
.v-expansion-panel:before {
  box-shadow: none !important;
}
.v-expansion-panel-header::before {
  background-color: transparent !important;
}
.v-expansion-panels {
  z-index: inherit !important;
}
.patient-section__header > .v-expansion-panel-header__icon::v-deep {
  display: inline-flex !important;
}
.v-expansion-panel:not(:first-child):after {
  border-top: none !important;
}
.v-expansion-panel--active + .v-expansion-panel,
.v-expansion-panel--active:not(:first-child) {
  margin-top: 0 !important;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: auto !important;
}
.v-expansion-panel-header {
  min-height: auto !important;
}
.mdi-chevron-down::before {
  content: '' !important;
  background-image: url("@/assets/img/checked/checked-grey.svg");
}
.patient-section {
  background-color: #f2f5f8 !important;
  padding: 21px 31px 21px 31px;
  width: 100%;
  height: auto !important;
  &__column {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    gap: 10px;
    transition: 0.3s;
  }
  &__description {
    color: var(--unfocus-color);
    font-size: 1rem;
  }
  &__header {
    padding: 0 !important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    margin: 0;
    &__select {
      background-image: url("@/assets/img/checked/checked-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 8px;
      &:focus {
        background-image: url("@/assets/img/checked/checked-grey-top.svg");
      }
    }
  }
  &__arrow {
    background-image: url("@/assets/img/checked/arrow-top-blue.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 20px;
    height: 10px;
  }
  &__body {
    margin: 20px 0 0 -24px;
    .patient-section {
      &__column {
       &:hover {
         color: #0489E0;
        }
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .patient-section {
    padding: 20px 15px;
    &__body {
      margin: 30px -24px;
    }
    .v-expansion-panel-content__wrap {
      padding: 0 !important;
    }
  }
  .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
}
@media print {
  .patient-section__description {
    display: none;
  }
}
</style>
